module.exports = __webpack_public_path__ + "img/lang-ru-hover.04522de7.png";